let UserTitle = function (tokenClient, serviceAddr) {
  let TokenClient = tokenClient;
  let ServiceBaseAddress = serviceAddr;
  /**
   * 获取所有职位
   * @param {any} success
   * @param {any} error
   */
  this.GetUserTitle = function (productId, success, error) {
    var url = ServiceBaseAddress + `/api/UserTitle/${productId}/%20`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.Titles = function (success, error) {
      var url = ServiceBaseAddress + '/api/UserTitle';
      TokenClient.Get(url, true, null, null,
          function (data) {
              if (success) {
                  var jsonObj = JSON.parse(data);
                  success(jsonObj);
              }
          }, error);
  }

  this.categoryTitles = function (categoryId, success, error) {
      var url = ServiceBaseAddress + '/api/UserTitle/Category/' + categoryId;
      TokenClient.Get(url, true, null, null,
          function (data) {
              if (success) {
                  var jsonObj = JSON.parse(data);
                  success(jsonObj);
              }
          }, error);
  }
}

export { UserTitle }
